var render, staticRenderFns
import script from "./orders-chart.vue?vue&type=script&lang=js&"
export * from "./orders-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b9700",
  null
  
)

export default component.exports